"use client";
import React from "react";
import { HotelListBannersQuery } from "@/types/generated";
import { BannerBrand, IBanner } from "./BannerBrand";
import { BannerHotelList } from "./BannerHotelList";
import { HotelBrandItemNullable } from "@app/[locale]/brands/[brand_slug]/page";

interface IBrandImageProps {
  bannerHotelList?: HotelListBannersQuery;
  brandData?: IBanner;
  currentBrand?: HotelBrandItemNullable;
}

/**
 * BannerSection component
 * Conditionally renders either a brand banner or a hotel list banner based on provided props.
 * Used to display the appropriate banner section in hotel result pages.
 */

const BannerSection: React.FC<IBrandImageProps> = ({
  bannerHotelList,
  brandData,
  currentBrand,
}) => {
  function getBannerComponent() {
    if (currentBrand && brandData) {
      return <BannerBrand brandData={brandData} />;
    }

    if (bannerHotelList) {
      return <BannerHotelList bannerHotelList={bannerHotelList} />;
    }

    return <></>;
  }

  // Render brand or hotel list banner depending on props
  return <>{getBannerComponent()}</>;
};

export { BannerSection };
